import React from 'react';
import { useNavigate } from 'react-router-dom';
import { searchContext, userAppContext } from '../../context/Context';
import { SearchButtonProps, SearchContext } from '../../types';
import { DATASETS } from '@/components/Constants';
import SharedButton from '../Button/Button';
import { UserAppContextType } from '../../router/types';
import { slugifyTrackingValue, trackEvent } from '@/utils/analytics';

export default function SearchButton({
  setValue,
  className = '',
  children = 'Search',
  variant = 'primary',
  size = 'md',
  iconLeft,
  iconRight,
  id,
  hasImg,
  imgSrc,
}: SearchButtonProps) {
  const navigate = useNavigate();
  const { searchItems } = searchContext() as unknown as SearchContext;
  const { restrictSources, groups } = userAppContext() as unknown as UserAppContextType;

  const handleSubmit = (evt: React.MouseEvent) => {
    evt.preventDefault();
    const buttonId = id ? String(id) : `search_button_${slugifyTrackingValue(children as string) || 'default'}`;
    trackEvent({
      name: 'search_submit',
      buttonId,
      label: 'Search button',
      page: 'global',
      section: 'search_bar',
      feature: 'search',
      eventGroup: 'search',
      eventCategory: 'search',
    });

    let idents = 'ALL';
    let view = 'ALL';
    let tab = 'GDA';

    if (searchItems!.length > 0) {
      idents = searchItems!.map(item => item.id).join('-');
      view = searchItems![0].dataset;
      tab = view === DATASETS.VARIANTS ? 'VDA' : 'GDA';
    }

    const isAcademic = groups?.includes('ROLE_ACADEMIC');
    const source = restrictSources === 'CURATED' || isAcademic ? 'CURATED' : 'ALL';

    navigate({
      pathname: '/search',
      search: `?view=${view}&idents=${idents}&source=${source}&tab=${tab}`,
    });

    setValue('');
  };

  return (
    <>
      {hasImg ? (
        <img
          id={id as string}
          src={imgSrc}
          alt="Search Button"
          className={className}
          onClick={handleSubmit}
          role="button"
          tabIndex={0}
          style={{ zIndex: 10 }}
        />
      ) : (
        <SharedButton
          id={id as string}
          onClick={handleSubmit}
          className={className}
          variant={variant}
          size={size}
          iconLeft={iconLeft}
          iconRight={iconRight}
        >
          {children}
        </SharedButton>
      )}
    </>
  );
}
